import Button from '@ui-kit/components/Button';
import { ModalActions } from '@ui-kit/components/Modal/Modal';
import { useTranslation } from 'react-i18next';
import type { ModalProps } from '@/components/ModalRenderer/components/types';
import { Modal } from '@/components/ModalRenderer/Modal';
import { DataList, DataListItem, DataListLabel, DataListValue } from '@/ui-kit/components/DataList';

type Payload = { validThrough: string };
type Props = ModalProps<Payload>;

const ConfirmTerminateIdProtect = ({ payload, confirmAction }: Props) => {
  const { t } = useTranslation(['Modal', 'Common']);
  const { validThrough } = payload;

  return (
    <Modal title={t('ConfirmTerminateIdProtect.title')}>
      <div className="flex flex-col gap-4">
        <p>{t('ConfirmTerminateIdProtect.info')}</p>
        <DataList>
          <DataListItem>
            <DataListLabel>{t('ConfirmTerminateIdProtect.validThrough')}</DataListLabel>
            <DataListValue>{t('Common:shortDate', { date: new Date(validThrough) })}</DataListValue>
          </DataListItem>
        </DataList>
      </div>
      <ModalActions>
        <Button variant="destructive" onClick={() => confirmAction?.()}>
          {t('ConfirmTerminateIdProtect.button')}
        </Button>
      </ModalActions>
    </Modal>
  );
};

export default ConfirmTerminateIdProtect;
